var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":_vm.modalTitle},on:{"on-hide":_vm.resetFormData}},[_c('compliance-document-coverages-form',{key:_vm.formKey,attrs:{"document-type":_vm.documentType},on:{"on-submit":_vm.create,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }